import { Badge, Button, IntelSignalCard } from 'design-system';
import { ChevronRightIcon } from 'lucide-react';

import type { MonthlyRecapsArticle } from '@/features/monthly-recaps';

type MonthlyRecapsArticleTeaserVariant = 'row' | 'single';

type MonthlyRecapsArticleTeaserProps = {
  article: MonthlyRecapsArticle;
  onClick: (trigger: HTMLButtonElement) => void;
  variant?: MonthlyRecapsArticleTeaserVariant;
};

const DESCRIPTION_CHAR_LIMIT = 240;

const truncateDescription = (description: string): string =>
  description.length > DESCRIPTION_CHAR_LIMIT
    ? `${description.slice(0, DESCRIPTION_CHAR_LIMIT)}...`
    : description;

export const MonthlyRecapsArticleTeaser = ({
  article,
  onClick,
  variant = 'row'
}: MonthlyRecapsArticleTeaserProps) => {
  const description =
    variant === 'single' ? article.description : truncateDescription(article.description);

  return (
    <IntelSignalCard
      action={
        <Button
          variant='link'
          onClick={event => {
            onClick(event.currentTarget);
          }}
        >
          Read full article
          <ChevronRightIcon aria-hidden />
        </Button>
      }
      timestamp={article.date}
      title={article.headline}
    >
      <div className='mb-2 flex flex-wrap gap-2'>
        <Badge>{article.month}</Badge>
        <Badge>{article.region}</Badge>
      </div>
      <p>{description}</p>
    </IntelSignalCard>
  );
};
